import { useHistory } from "react-router-dom";

import useMountEffect from "../../Components/hooks/useMountEffect";

const SpotPricingRedirect = () => {
  const history = useHistory();
  useMountEffect(() => {
    window.open("https://compute.doit.com/spot", "_blank", "noopener");
  });
  history.goBack();
  return null;
};

export default SpotPricingRedirect;
